'use client'

import type { AddToCartTypes } from '@maestro/commerce-blocks/components/product-card/product-card.types'
import type { Product } from '@maestro/data-layer'

import { useState } from 'react'

import { theme } from '@maestro/local/theme'

interface UseProductCardQuantityPickerProps {
  product: Product
  addToCartType: AddToCartTypes
}

export const useProductCardQuantityPicker = (
  props: UseProductCardQuantityPickerProps
) => {
  const { product, addToCartType } = props

  const [quantity, setQuantity] = useState(1)

  const requiresSelection =
    product.variants.length > 1 &&
    !product.variants.some((variant) => variant.id === product.id)

  const displayQuantityPicker =
    theme().product.details.isQuantityPickerEnabled &&
    addToCartType !== 'none' &&
    !requiresSelection

  return {
    quantity,
    setQuantity,
    maxQuantity: theme().cms.quantityCounterMaxValue,
    displayQuantityPicker,
  }
}
